import { connect } from 'react-redux';
import { getTokenFromLocation } from '../../../reducers/account/activation';
import ActivateUserAccount from './ActivateUserAccount';
import { getTranslation } from "../../../reducers/common/localization";
import { getSubmitFormSuccessStatus } from '../../../reducers/common/submitForm';
import { getUserRole, getUserDataError, getLoadingDataByToken, fetchGetUserDataByToken } from '../../../reducers/account/userData';

const mapStateToProps = (state, { location }) => {
    return {
        loading: getLoadingDataByToken(state),
        role: getUserRole(state),
        error: getUserDataError(state),
        success: getSubmitFormSuccessStatus(state),
        token: getTokenFromLocation(location),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetUserData: (token) => {
            dispatch(fetchGetUserDataByToken(token))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivateUserAccount);



// WEBPACK FOOTER //
// ./src/components/accountManagement/activateUserAccount/ActivateUserAccount.container.js